import { duplicateNumberErrorCode } from '../const';
import styles from './../../style.module.scss';

type IconProps = {
  iconType: string;
  className: string;
};

export const getLoanStatusIconProps = (errorCode?: string): IconProps | null => {
  if (!errorCode) return null;
  if (duplicateNumberErrorCode.includes(errorCode)) {
    return {
      iconType: 'icon_warning',
      className: styles.warningIcon
    };
  }

  return null;
};
